/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  GetStatsByDateOverviewQueryParams,
  GetStatsByDateOverview200,
  GetStatsByDateOverview400,
  GetStatsByDateOverviewQueryResponse,
} from '../entities/GetStatsByDateOverview'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1StatsByDateOverviewResponseSchema } from './v1/statsByDateOverviewResponseSchema'
import { z } from 'zod'

export const getStatsByDateOverviewQueryParamsSchema = z
  .object({
    drivee_city_id: z.number().int().describe('ID города в Drivee').optional(),
    from: z.string().describe('Начальная дата').optional(),
    to: z.string().describe('Конечная дата').optional(),
  })
  .optional() as unknown as ToZod<GetStatsByDateOverviewQueryParams>

/**
 * @description OK
 */
export const getStatsByDateOverview200Schema = z.lazy(() => v1StatsByDateOverviewResponseSchema) as unknown as ToZod<GetStatsByDateOverview200>

/**
 * @description Bad Request
 */
export const getStatsByDateOverview400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetStatsByDateOverview400>

export const getStatsByDateOverviewQueryResponseSchema = z.lazy(() => getStatsByDateOverview200Schema) as unknown as ToZod<GetStatsByDateOverviewQueryResponse>